export default "__VITE_ASSET__DtNEurSj__"